import {obtenerFechaEstandarCheckIn} from "../Funciones/obtenerFechaEstandarCheckIn";
import {obtenerFechaEstandarCheckOut} from "../Funciones/obtenerFechaEstandarCheckOut";
import {fire} from "../../fire";
import {collection, or, query, where} from "firebase/firestore";
import {obtenerColeccionQuery} from "../../Servicios/BD/obtenerColeccionQuery";
import {COLECCIONRESERVAS, ESTADOSRESERVAS, FECHACHECKIN, FECHACHECKOUT} from "../Constantes";

export const obtenerReservasDia = async ({fechaDia}) => {

    let fechaCheckInStandar = obtenerFechaEstandarCheckIn(fechaDia)
    let fechaCheckOutStandar = obtenerFechaEstandarCheckOut(fechaDia)

    let col = collection(fire, COLECCIONRESERVAS)
    let q = query(col, or(where(FECHACHECKIN, '==', fechaCheckInStandar),
        where(FECHACHECKOUT, '==', fechaCheckOutStandar),
        where('estado', '==', ESTADOSRESERVAS[1]),
        where('estado', '==', ESTADOSRESERVAS[3]),
    ))

    let dox = await obtenerColeccionQuery(q)

    //Luego corregir
    //Quitamos los completados
    let arr = []
    for (let i = 0; i < dox.data.length; i++) {
        if (dox.data[i].estado !== ESTADOSRESERVAS[4]) {
            arr.push(dox.data[i])
        }
    }

    return arr

}